<template>
  <div class="m-portlet">
    <div class="m-portlet__head">
      <div class="m-portlet__head-caption">
        <div class="m-portlet__head-title">
          <h3 class="m-portlet__head-text">
            Services
          </h3>
        </div>
      </div>
    </div>
    <div class="m-portlet__body">
      <div class="flex align-items-center">
        <input
          placeholder="Service name"
          style="width: 200px; margin-right: 10px;"
          type="text"
          class="form-control"
          v-model="service_name">
        <div class="btn btn-jet" @click="add()">Create</div>
      </div>
      <div class="flex mt-3">
        <div class="tag mr-1 mb-1" v-for="service in services">
          <span>{{ service.name }}</span>
          <span class="ml-1 pointer" @click="remove(service)">x</span>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  created() {
    this.axios.get('/n/services').then(response => {
      this.services = response.data.data
    })
  },
  data() {
    return {
      services: [],
      service_name: null,
    }
  },
  methods: {
    add() {
      this.axios.post('/n/services', {name: this.service_name}).then(response => {
        this.services.push(response.data.data)
        this.service_name = null
      })
    },
    remove(service) {
      if (!confirm('Are you sure? All tasks will lose this service.')) {
        return
      }

      this.axios.delete('/n/services/' + service.id).then(response => {
        this.services = _.reject(this.services, s => s.id == service.id)
      })
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/views/config/services.vue